import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
export function refToCallback(ref) {
  return function (newValue) {
    if (typeof ref === 'function') {
      ref(newValue);
    } else if (ref != null) {
      ref.current = newValue;
    }
  };
}
var weakMem = new WeakMap();

var weakMemoize = function weakMemoize(ref) {
  if (weakMem.has(ref)) {
    return weakMem.get(ref);
  }

  var cb = refToCallback(ref);
  weakMem.set(ref, cb);
  return cb;
};

export function useRefToCallback(ref) {
  return weakMemoize(ref);
}